import { dataHooks } from '@wix/data-hooks'

export const wixStudioSplitV3DataHooks = dataHooks<{
  title: {}
  subtitle: {}
  option: { key: string }
  secondaryOption: { key: string }
  disclaimer: {}
  skip: {}
}>('wix-studio-split-v3')
